<h2 mat-dialog-title>About FitForce</h2>
<mat-dialog-content fxLayout="column">
  <p>Version: {{ version }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" fxFlex mat-dialog-close>Close</button>
</mat-dialog-actions>
